import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    StocktakeCountDTO,
    StocktakeCreateDTO,
    StocktakeDTO,
    StocktakeResponse,
} from '../interfaces/stocktake.interface';
import { AuthService } from './auth.service';

export const StocktakeService = {
    getStocktakesByInstitution: async (
        status: string = '',
        page: number = 0,
        size: number = 10,
    ): Promise<StocktakeResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const statusParam = status ? `&status=${status}` : '';
        const response = await axios.get(
            `${ENDPOINTS.STOCKTAKE.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}${statusParam}`,
        );
        return response.data;
    },

    getStocktakeById: async (id: string): Promise<StocktakeDTO> => {
        const response = await axios.get(ENDPOINTS.STOCKTAKE.GET_BY_ID(id));
        return response.data;
    },

    createStocktake: async (stocktake: StocktakeCreateDTO): Promise<StocktakeDTO> => {
        const response = await axios.post(ENDPOINTS.STOCKTAKE.CREATE, stocktake);
        return response.data;
    },

    submitCounts: async (id: string, counts: StocktakeCountDTO[]): Promise<StocktakeDTO> => {
        const response = await axios.post(ENDPOINTS.STOCKTAKE.COUNTS(id), counts);
        return response.data;
    },

    approveStocktake: async (id: string): Promise<StocktakeDTO> => {
        const response = await axios.post(ENDPOINTS.STOCKTAKE.APPROVE(id));
        return response.data;
    },

    cancelStocktake: async (id: string): Promise<StocktakeDTO> => {
        const response = await axios.post(ENDPOINTS.STOCKTAKE.CANCEL(id));
        return response.data;
    },
};
